import type Position from "@/util/Position.ts";

export function getAngleDegrees(origin: Position, pointer: Position): number {
    return Math.atan2(pointer.y - origin.y, pointer.x - origin.x) * 180 / Math.PI;
}

export function normalizeDegrees(angle: number): number {
    return ((angle + 180) % 360 + 360) % 360 - 180;
}

export function snapDegrees(angle: number, step: number): number {
    if (step <= 0) return normalizeDegrees(angle);
    return normalizeDegrees(Math.round(angle / step) * step);
}

export function getRotationDelta(
    pivot: Position,
    startPointer: Position,
    currentPointer: Position,
): number {
    return normalizeDegrees(
        getAngleDegrees(pivot, currentPointer) - getAngleDegrees(pivot, startPointer)
    );
}
